//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CalendarComponent',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ''
    },
    classstyle: {
      type: String,
      default: 'col'
    },
    hide_details: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      required: true
    }
  },
  data: function data() {
    return {
      model: this.value,
      menu: false
    };
  },
  watch: {
    model: function model(newValue) {
      this.$emit('input', newValue.value ? newValue.value : newValue);
    },
    value: function value(newValue) {
      this.model = newValue.value ? newValue.value : newValue;
    }
  },
  created: function created() {},
  methods: {}
};